import { Controller } from 'react-hook-form'
import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    VStack,
} from '@chakra-ui/react'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'

export function PenaltyNumberInput() {
    const { zodForm, isPenaltyOrderRequired, isFormDisabled } = useMatchEditorFormContext()

    if (!isPenaltyOrderRequired) {
        return null
    }

    return (
        <VStack mb={8} minW="90px" maxW="25%">
            <Controller
                control={zodForm.control}
                name="penalty_order"
                render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                    <FormControl isRequired isDisabled={isFormDisabled}>
                        <FormLabel htmlFor="penalty_order">Shoot #</FormLabel>
                        <NumberInput
                            min={1}
                            defaultValue={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            isDisabled={isFormDisabled}
                            isInvalid={!!error}
                            isRequired
                            value={value ?? 0}>
                            <NumberInputField ref={ref} name={name} />
                            <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                            </NumberInputStepper>
                        </NumberInput>
                        <FormErrorMessage>{zodForm.formState.errors.penalty_order?.message}</FormErrorMessage>
                    </FormControl>
                )}
            />
        </VStack>
    )
}
